import { isSafari as isSafariBrowser } from '../browser'
import { contains, focus, getOwnerDocument, isActiveElement } from '../dom'
import { isRef } from '../react-utils'
import { usePointerEvent } from './usePointerEvent'

/**
 * Polyfill to get `relatedTarget` working correctly consistently
 * across all browsers.
 *
 * It ensures that elements receives focus on pointer down if
 * it's not the active element.
 *
 * @internal
 */
export function useFocusOnPointerDown(props) {
  const { ref, elements, enabled } = props

  const isSafari = isSafariBrowser()
  const doc = () => getOwnerDocument(ref.current)

  usePointerEvent(doc, 'pointerdown', event => {
    if (!isSafari || !enabled) return
    const target = event.target

    const els = elements ?? [ref]
    const isValidTarget = els.some(elementOrRef => {
      const el = isRef(elementOrRef) ? elementOrRef.current : elementOrRef
      return contains(el, target)
    })

    if (!isActiveElement(target) && isValidTarget) {
      event.preventDefault()
      focus(target)
    }
  })
}
